export default "__VITE_ASSET__DkICw41O__"